import React, { useEffect, useState } from 'react';
import SalesByLocationWidget from './SalesByLocationWidget';
import SalesByProductWidget from './SalesByProductWidget';
import TransactionsWidget from './TransactionsWidget';
import DeviceErrorsWidget from './DeviceErrorsWidget';


import FinancialReportWidget from './FinancialReportWidget';
import CriticalProductConditionWidget from './CriticalProductConditionWidget';
import { DashboardProvider } from '../../context/DashboardContext';



const Dashboard = (props) => {

    return (
        <DashboardProvider>
            <div className='dashboard-container'>            
                <FinancialReportWidget />
                <SalesByLocationWidget />
                <SalesByProductWidget />
                <TransactionsWidget />
                <CriticalProductConditionWidget />
                <DeviceErrorsWidget />
            </div>
        </DashboardProvider>
    )
}

export default Dashboard;